import { EVENT_TYPES } from "nemuru-components";
import { modules } from "../../components/modules";
import { FLOW_MESSAGES } from "../../components/shared/components/flowMessages/components";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../components/shared/config";
import { MILESTONES } from "../../components/shared/sharedKernel/EventCatcher/config";
import { findParticipantOnboardingDetailsByRole } from "../../utils/participants";
import { oKBehaviours, SECTIONS } from "../config";
import { BankReaderName } from "../../components/modules/income/BankReader/components/BankReaderFactory/types/BankReaderName";
import { ENV_DEFAULT_BANK_READER } from "../envVars";

export const flowBREnabled = {
  name: "BR enabled",
  modules: [
    {
      id: modules.QUOTA_ADJUSTMENT.id,
      onKO: {
        id: modules.QUOTA_ADJUSTMENT.id,
        onOK: oKBehaviours.NEXT_FLOW_ITEM,
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_LOAN_CONDITIONS_END.id,
          fadeIn: true,
        },
      },
      section: {
        name: SECTIONS.LOAN_CONDITIONS,
        progressPercentage: "50%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination &&
          processState.participant.role ===
            ONBOARDING_PARTICIPANT_ROLES.BORROWER,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.FULL_KYC_AUTOMATIC.id,
      onKO: {
        id: modules.KYC_MANUAL.id,
        onOK: oKBehaviours.NEXT_FLOW_ITEM,
      },
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.BANK_READER.id,
      onKO: {
        id: modules.DECLARED_INCOME.id,
        onOK: oKBehaviours.NEXT_FLOW_ITEM,
      },
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "50%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.borrower_user_details_on_origination
            ?.familiar_situation_details &&
          !processState.loan?.borrower_bank_reader_id &&
          !processState.loan?.declared_income_id,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.CASH_IN_CASH_OUT_METHOD.id,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "75%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          ENV_DEFAULT_BANK_READER === BankReaderName.TINK &&
          !processState.loan?.borrower_cash_in_cash_out_method_id &&
          findParticipantOnboardingDetailsByRole(
            processState.loan,
            ONBOARDING_PARTICIPANT_ROLES.BORROWER
          )?.borrower_bank_reader_id &&
          processState.participant.role ===
            ONBOARDING_PARTICIPANT_ROLES.BORROWER,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.PROFESSIONAL_DATA.id,
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "100%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.PROFESSIONAL_DETAILS_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination
            ?.professional_details,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.DECLARED_INCOME_ON_CONDITIONS.id,
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "100%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_FINANCES_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.INCOME_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.income?.valid !== true,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.SUMMARY_AND_ADJUST.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "33%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.APPLICATION_CREATED_IN_LENDER,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },

      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) => {
          return (
            !processState.loan?.loan_application_selected ||
            processState.loan?.loan_application_ids?.length === 0 ||
            !processState.loan?.loan_application_ids
          );
        },
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "66%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids &&
          processState.loan?.loan_application_ids?.length > 0,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.DOCUMENTATION.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "80%",
      },
    },
    {
      id: modules.OPTINS_AND_SIGNATURE.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "100%",
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      onKO: null,
      section: {
        name: null,
      },
    },
  ],
};
